export const COMMENT_FORM_PLACEHOLDER = 'comment-form.placeholder';
export const COMMENT_FORM_REPLY_BOX = 'comment-form.reply-box';
export const COMMENT_FORM_REPLY_BOX_CANCEL_BUTTON_LABEL = 'comment-form.reply-box-cancel-button-label';
